<template>
  <div class="memberlist">
    <p>
      <span v-if="isApprovalList">{{ $t('manageMember.approvalPendingCount',
        { count: userCount })}}</span>
      <span v-else>{{ $t('manageMember.totalMemberCount', { count: userCount }) }}</span>
    </p>

    <table>
      <caption>Member list</caption>
      <thead>
        <tr>
          <th scope="col"><input type="checkbox" name="all"
            :checked="isAllSelected"
            :disabled="!userCount"
            @click="toggleSelectAll" ></th>
          <th scope="col">No</th>
          <th scope="col">BUSINESS TYPE</th>
          <th scope="col">Company</th>
          <th scope="col">ID</th>
          <th scope="col">TEL</th>
          <th scope="col">Date fo Sign Up</th>
          <th scope="col" v-if="isApprovalList">{{ $t('manageMember.function') }}</th>
          <th scope="col" v-else>{{ $t('manageMember.deleteAccount') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in users" :key="item.id">
          <td><input type="checkbox" name="all"
            :value="item.id"
            v-model="selectedIds"></td>
          <td>{{ index + 1 }}</td>
          <td>{{ item.Company.CompanyType.name }}</td>
          <td>{{ item.Company.name }}</td>
          <td>{{ item.email }}</td>
          <td>{{ `+${item.callingCode} ${item.phone}` }}</td>
          <td>{{ item.createdAt | yymmdd }}</td>
          <td>
            <template v-if="isApprovalList">
              <button type="button" class="approval_btn"
                @click="onApproveClick([item.id])">{{ $t('common.approve') }}</button>
              <button type="button" class="approval_btn"
                @click="onDeclineClick([item.id])">{{ $t('common.decline') }}</button>
            </template>
            <button v-else type="button" class="approval_btn"
              @click="onRemoveClick([item.id])">{{ $t('manageMember.deleteAccount') }}</button>
          </td>
        </tr>
        <tr v-if="noResultMessage">
          <td colspan="8">
            {{ noResultMessage }}
          </td>
        </tr>
      </tbody>
    </table>

    <template v-if="userCount">
      <div v-if="isApprovalList">
        <button type="button"
          @click="onApproveClick(selectedIds, true)"
          :disabled="!selectedIds.length">{{ $t('manageMember.approveSelected') }}</button>
        <span>|</span>
        <button type="button"
          @click="onDeclineClick(selectedIds, true)"
          :disabled="!selectedIds.length">{{ $t('manageMember.declineSelected') }}</button>
      </div>
      <div v-else>
        <button type="button"
          @click="onRemoveClick(selectedIds, true)"
          :disabled="!selectedIds.length">{{ $t('manageMember.deleteSelected') }}</button>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import modalEvent from '@/lib/modal-event'
import manageUesrData from '@/data/manage-user'

export default {
  name: 'UserList',
  props: ['users', 'menuName', 'userQuery'],
  data () {
    return {
      selectedIds: []
    }
  },
  computed: {
    isApprovalList () {
      return this.menuName === 'ManageApproval'
    },
    userCount () {
      return this.users.length
    },
    isAllSelected () {
      return this.userCount && this.userCount === this.selectedIds.length
    },
    noResultMessage () {
      if (this.userCount) {
        return null
      }

      if (this.userQuery) {
        return this.$t('manageMember.noResult')
      } else {
        if (this.isApprovalList) {
          return this.$t('manageMember.noApprovalPending')
        } else {
          return this.$t('manageMember.noMember')
        }
      }
    }
  },
  methods: {
    toggleSelectAll () {
      if (this.isAllSelected) {
        this.selectedIds = []
      } else {
        this.selectedIds = _.map(this.users, item => {
          return item.id
        })
      }
    },
    onApproveClick (ids, isBatch) {
      const actionType = isBatch ? 'grantSelectedUser' : 'grantUser'

      this.showConfirmDialog(actionType).then(result => {
        if (result) {
          this.$emit('onApproveClick', ids)
        }
      })
    },
    onDeclineClick (ids, isBatch) {
      const actionType = isBatch ? 'rejectSelectedUser' : 'rejectUser'

      this.showConfirmDialog(actionType).then(result => {
        if (result) {
          const actionData = { reason: result }
          this.$emit('onDeclineClick', ids, actionData)
        }
      })
    },
    onRemoveClick (ids, isBatch) {
      const actionType = isBatch ? 'removeSelectedUser' : 'removeUser'

      this.showConfirmDialog(actionType).then(result => {
        if (result) {
          this.$emit('onRemoveClick', ids)
        }
      })
    },
    showConfirmDialog (actionType) {
      const data = _.cloneDeep(manageUesrData[actionType])
      return modalEvent.openDialog(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/UserList.vue